module.exports = "@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0,500;0,700;1,400&display=swap);\n/*sizes*/\n"